<template>
  <div>
    <div class="container">
      <div class="head">
        <div style="display:flex;justify-content:space-between;">
          <div class="title">
            <div class="text">{{ projectName }}</div>
            <div class="tag-box">
              <txtTag class="tag" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'">{{ detailsInfo.areaName }}
              </txtTag>
              <txtTag class="tag" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'">
                {{ detailsInfo.areaType == 1 ? '一' : '二' }}类地区</txtTag>
              <txtTag class="tag" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'">{{ quarterName }}</txtTag>
            </div>
          </div>
        </div>
        <div class="rules">
          <div class="branch">-{{ assessDetail.deduction }}</div>
          <div class="num">{{ areaCont.score }}/{{ areaCont.totalScore }}</div>
        </div>
      </div>
      <div class="date" v-if="assessDetail.deductionTime">{{ assessDetail.deductionTime }}20191225</div>
    </div>
    <div class="pg-pd12" v-if="assessDetail.detailVisible === 'true'">
      <div>
        <causeDeduction :causeContent="causeContent" causeTitle="扣分原因"></causeDeduction>
      </div>
      <!-- 投诉处置率详情 -->
      <div class="main" v-if="complainInfo">
        <div class="title">{{ complainInfo.title }}</div>
        <div class="content">
          <div class="deduc-item">
            <div class="name">投诉量</div>
            <div class="cont">{{ complainInfo.complainNum }}起</div>
          </div>
          <div class="deduc-item" v-if="complainInfo.touristNum">
            <div class="name">接待人次</div>
            <div class="cont">{{ complainInfo.touristNum }}万次</div>
          </div>
          <div class="deduc-item" v-if="complainInfo.complainRate">
            <div class="name">
              <div>万人投诉率</div>
              <div class="txt">投诉率=投诉量÷接待人次</div>
            </div>
            <div class="cont">{{ complainInfo.complainRate }}%</div>
          </div>
          <div class="deduc-item" v-if="complainInfo.donetimeAvg">
            <div class="name">
              <div>平均办结时长</div>
              <div class="txt">平均办结时长=有效已办结投诉件处理时长÷有效已办结投诉件数</div>
            </div>
            <div class="cont">{{ complainInfo.donetimeAvg }}分钟</div>
          </div>
          <div class="deduc-item">
            <div class="name">排名</div>
            <div class="cont">{{ complainInfo.ranking }}</div>
          </div>
        </div>
      </div>
      <!-- 州市投诉处置率列表 -->

      <template v-if="tableList && tableList.length > 0">
        <div class="complain" v-if="complainListUrlInfo" @click="toComplaintDetails()">
          <span>查看投诉案件列表</span>
        </div>
        <complainForm :tableList="tableList" :areaName="areaName"></complainForm>
      </template>
      <!-- 投诉处置满意度详情 -->
      <div class="main" v-if="compDoneSatisInfo">
        <div class="title">投诉处置情况</div>
        <div class="content pd0">
          <div class="tongji line_bottom">
            <div class="tj-item line_right">
              <div class="name">满意</div>
              <div class="num">{{ compDoneSatisInfo.satisfyingNum }}<span>起</span></div>
            </div>
            <div class="tj-item line_right">
              <div class="name">基本满意</div>
              <div class="num">{{ compDoneSatisInfo.satisfiedNum }}<span>起</span></div>
            </div>
            <div class="tj-item">
              <div class="name">总数</div>
              <div class="num">{{ compDoneSatisInfo.complainNum }}<span>起</span></div>
            </div>
          </div>
          <div class="ts-list" @click="toComplaintDetails()">
            查看投诉件列表
            <img class="img" src="../../assets/image/t-right.png" />
          </div>
        </div>
      </div>

      <!-- 相关材料 -->
      <template v-if="assessFile">
        <materialScience :caseList="assessFile" title="相关材料"></materialScience>
      </template>

    </div>
    <!-- 没有扣分记录提示 -->
    <div v-if="assessDetail.detailVisible === 'false'" class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
  </div>
</template>
<script>
import causeDeduction from './components/causeDeduction'; // 扣分原因
import complainForm from './components/form'; // 表格
import materialScience from './components/materialScience'; // 相关材料
import nodata from './components/nodata'; // 没有数据
import txtTag from './components/txt-tag';
import api from '../../service/modules/appraise';
import apis from '../../service/modules/index';
import {
  isError
} from 'util';
import apimessage from '../../service/modules/message'
// import { detailsInfo } from '../../service/modules/complaint';

export default {
  components: {
    causeDeduction,
    complainForm,
    materialScience,
    nodata,
    txtTag
  },

  data() {
    return {
      noData: {
        title: '暂无数据'
      },
      projectName: '',
      assessDetail: {},
      deduction: '',
      id: '',
      subType: '',
      // 相关材料列表
      assessFile: [],
      complainInfo: '',
      causeContent: '',
      tableList: [],
      compDoneSatisInfo: {},
      detailsInfo: {},
      complainListUrlInfo: {},
      areaCont: {},
      quarterName: this.$route.query.quarterName

    }
  },

  computed: {},

  watch: {},

  methods: {
    // 考核明细接口
    getSubAssessDetail() {
      api.getAssessDetailById({
        id: this.id,
        subType: this.subType
      }).then(res => {
        if (res.ret === 0) {
          this.assessDetail = res.data.assessDetail
          this.causeContent = res.data.assessDetail.deductionReason // 扣分原因
          if (res.data.assessDetail.complainRateInfo) {
            this.complainInfo = res.data.assessDetail.complainRateInfo // 投诉率详情
            this.complainInfo.title = '游客投诉率详情'
          } else if (res.data.assessDetail.compDoneRateInfo) {
            this.complainInfo = res.data.assessDetail.compDoneRateInfo // 投诉率详情
            this.complainInfo.title = '游客投诉处置效率详情'
          }
          if (res.data.assessDetail.complainRateList) {
            this.tableList = res.data.assessDetail.complainRateList
          } else if (res.data.assessDetail.compDoneRateList) {
            this.tableList = res.data.assessDetail.compDoneRateList // 州市投诉率列表
          }
          this.assessFile = res.data.assessDetail.assessFile // 相关材料
          this.compDoneSatisInfo = res.data.assessDetail.compDoneSatisInfo // 投诉处置满意度详情
          this.complainListUrlInfo = res.data.assessDetail.complainListUrlInfo
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    toComplaintDetails() {
      // this.$router.push(`/complaint/checkList?type=${this.complainListUrlInfo.urlParams.type}&areaOne=${this.areaCont.area}&fullAdress=${encodeURI(this.areaCont.areaName)}&year=${this.areaCont.year}&quarter=${this.quarter}`)
      window.yyn.invokeJSB(
        'openWindow', {
        openUrl: `${this.globalApp.getSystemInfo().host}/web/#/complaint/checkList?type=${this.complainListUrlInfo.urlParams.type}&areaOne=${this.areaCont.area}&fullAdress=${encodeURI(this.areaCont.areaName)}&year=${this.areaCont.year}&quarter=${this.quarter}`,
        isFullScreen: 0,
        setTitle: '',
        needLoading: 1
      },
        cb => {
          console.log(cb, 'callback');
        }
      );
    },
    // 消息单条已读
    onMessageReadOne(isRead, id) {
      if (isRead === 'false') {
        apimessage.messageReadOne({ messageId: id }).then(res => {
          localStorage.setItem('messageId', id)
        })
      }
    }
  },

  mounted() { },

  created() {
    let messageId = this.$route.query.messageId || ''
    let isRead = this.$route.query.isRead || 'true'
    this.onMessageReadOne(isRead, messageId)

    this.id = this.$route.query.id
    this.subType = this.$route.query.assessType || ''
    this.detailsInfo = JSON.parse(sessionStorage.getItem('detailInfo')) || { areaType: this.$route.query.areaType || '', areaName: this.$route.query.areaName || '' }
    this.projectName = sessionStorage.getItem('projectName') || this.$route.query.projectName || ''
    this.areaCont = JSON.parse(sessionStorage.getItem('areaCont')) || { area: this.$route.query.area || '', areaName: this.$route.query.areaName || '', year: this.$route.query.year || '', score: this.$route.query.score || '', totalScore: this.$route.query.totalScore || '', quarter: this.$route.query.quater || '' }// 城市信息
    this.areaName = this.areaCont.areaName
    console.log(this.areaName, 'dfdf')
    console.log(this.areaCont, 'cont')
    this.quarter = Number(this.areaCont.quarter) - 1
    this.getSubAssessDetail()
  }

}
</script>
<style scoped lang="less">
@vv: 3.75vw;

.container {
  min-height: 100vh;
  background: rgba(251, 251, 251, 1);
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;

  .noData-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
  }

  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;

  }

  .head {
    width: 100%;
    background: #fff;
    padding: 24px 12px 12px 12px;

    //   .title{
    //     height:22px;
    //     line-height: 22px;
    //     display: flex;
    //     justify-content: space-between;
    //     align-items: center;
    //     .text{
    //       font-size:20px;
    //       font-family:PingFangSC-Medium,PingFang SC;
    //       font-weight:bold;
    //       color:rgba(51,51,51,1);
    //       line-height:20px;
    //     }
    //     .branch{
    //       height:22px;
    //       font-size:22px;
    //       font-family:DIN-Medium,DIN;
    //       font-weight:500;
    //       color:rgba(255,77,77,1);
    //       line-height:22px;
    //     }
    //   .no-de{
    //     font-size:20px;
    //     font-family:PingFangSC-Medium,PingFang SC;
    //     font-weight:bold;
    //     color:rgba(54,179,116,1);
    //     line-height:22px;
    //   }
    // }
    .title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-right: 50px;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }

      .tit {
        position: relative;
        display: flex;
        color: #999;
        font-size: 12px;
        margin-top: 12px;

        span {
          position: relative;
          padding-right: 16px;
        }

        span::after {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 12px;
          height: 12px;
          background: url(../../assets/image/t-right.png) no-repeat;
          background-size: 12px 12px;
        }
      }
    }

    .rules {
      display: flex;
      flex-direction: column;
      color: #666666;
      text-align: right;

      .num {
        color: #999999;
        font-size: 14px;
        margin-top: 8px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }

      .no-de {
        min-width: 60px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
      }

    }

    .tag-box {
      width: 173%;
      height: 28px;
      display: flex;
      align-items: center;
      margin-top: 10px;
      transform: scale(0.5);
      transform-origin: left 0;

    }

    .tip {
      margin-top: 16px;
      display: flex;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(54, 179, 116, 1);
      transform: scale(0.5);
      transform-origin: 0 0;
      height: 28px;

      .con {
        display: table;
        border: 2px solid rgba(54, 179, 116, 1);
        padding: 0 8px;
        margin-right: 16px;
        height: 28px;
        line-height: 28px;

        .label {
          display: table-cell;
          vertical-align: middle;
        }
      }
    }

    .date {
      margin-bottom: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
  }

  .main {
    margin-top: 24px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;
      padding: 16px;

      .deduc-item {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        padding-bottom: 12px;

        .name {
          color: #999999;
          max-width: 225px;

          .txt {
            font-size: 12px;
            margin-top: 4px;
            line-height: 16px;
          }
        }

        .cont {
          color: #333333;
        }
      }

      .deduc-item:last-child {
        padding-bottom: 0;
      }

      .tongji {
        display: flex;
        align-items: center;

        .tj-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          padding: 16px 0;
          text-align: center;

          .name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .num {
            font-size: 20px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            margin-top: 8px;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            position: relative;

            span {
              font-size: 10px;
              padding-left: 4px;
              font-weight: normal;
              position: absolute;
              float: left;
              display: inline-block;
              font-weight: normal;
              bottom: 2px;
            }
          }
        }

        .tj-item:last-child {
          border-right: 0;
        }
      }

      .ts-list {
        width: 100%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        position: relative;
        vertical-align: top;
        display: inline-block;
        text-align: center;
        line-height: 41px;

        .img {
          position: absolute;
          float: left;
          display: inline-block;
          width: 10px;
          height: 10px;
          top: 50%;
          transform: translateY(-50.5%);

          img {
            width: 100%;
          }
        }
      }
    }

    .pd0 {
      padding: 0;
    }
  }

  .complain {
    position: relative;
    line-height: 46px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 0 16px;
    margin-top: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .complain::after {
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background: url(../../assets/image/t-right.png) no-repeat;
    background-size: 12px 12px;
  }
}
</style>
